<template>
    <div class="container my-auto" :class="layout ? 'nch-navbar--fixed' : ''" v-if="loaded">
        <div :class="finishLoading ? 'bg-overlay' : ''">
            <card class="cart-card" v-if="plans.length > 0">
                <div class="cart-body"
                    v-if="pagSeguroFinishPayment === false && pagSeguroFinishPaymentPix === false && pagSeguroFinishPaymentBillet === false">
                    <h2 class="cart-title">{{ $t('cart.cart') }}</h2>
                    <div class="cart">
                        <CartItem v-for="plan in plans" :plan="plan" :key="plan.id" :has_coupon="has_coupon"
                            :invoice_id="invoice_id" />
                        <h2 v-if="pagSeguroFinishPayment === false" class="payment-type">{{ $t('cart.payment_type') }}
                        </h2>
                        <template v-if="!isFree && pagSeguroFinishPayment === false">
                            <div class="col-12 col-md-12 payment-method">
                                <div v-for="gate in gateways" :key="gate.id">
                                    <div class="group-buttons">
                                        <button type="button" :id="gate.slug"
                                            class="ma-2 custom-button"
                                            :class="{ active: gateway && gateway.slug === gate.slug }"
                                            @click="gateway = gate">
                                            <span v-if="gate.slug === 'cielo'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" viewBox="0 0 16 16">
                                                    <path
                                                        d="M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1z" />
                                                    <path
                                                        d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm13 2v5H1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-1 9H2a1 1 0 0 1-1-1v-1h14v1a1 1 0 0 1-1 1z" />
                                                </svg>
                                            </span>
                                            <span v-else-if="gate.slug === 'paypal'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M14.06 3.713c.12-1.071-.093-1.832-.702-2.526C12.628.356 11.312 0 9.626 0H4.734a.7.7 0 0 0-.691.59L2.005 13.509a.42.42 0 0 0 .415.486h2.756l-.202 1.28a.628.628 0 0 0 .62.726H8.14c.429 0 .793-.31.862-.731l.025-.13.48-3.043.03-.164.001-.007a.351.351 0 0 1 .348-.297h.38c1.266 0 2.425-.256 3.345-.91.379-.27.712-.603.993-1.005a4.942 4.942 0 0 0 .88-2.195c.242-1.246.13-2.356-.57-3.154a2.687 2.687 0 0 0-.76-.59l-.094-.061ZM6.543 8.82a.695.695 0 0 1 .321-.079H8.3c2.82 0 5.027-1.144 5.672-4.456l.003-.016c.217.124.4.27.548.438.546.623.679 1.535.45 2.71-.272 1.397-.866 2.307-1.663 2.874-.802.57-1.842.815-3.043.815h-.38a.873.873 0 0 0-.863.734l-.03.164-.48 3.043-.024.13-.001.004a.352.352 0 0 1-.348.296H5.595a.106.106 0 0 1-.105-.123l.208-1.32.845-5.214Z" />
                                                </svg>
                                            </span>
                                            <span
                                                v-else-if="gate.name === 'Santander' || gate.name === 'Banco do Brasil' || gate.name === 'Caixa Econômica' || gate.name === 'Itaú' || gate.name === 'Bradesco'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z" />
                                                </svg>
                                            </span>
                                            <span v-else-if="gate.slug === 'pagseguro'">
                                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16"
                                                    height="16">
                                                    <path
                                                        d="M17.482 9.712c1.64 0 3.108.69 4.1 1.813.044-.388.087-.777.087-1.208C21.67 5.007 17.353.69 12 .69c-5.353 0-9.67 4.316-9.67 9.626 0 .345 0 .69.044 1.036a8.688 8.688 0 017.943-5.137c2.848 0 5.352 1.381 6.95 3.496h.215zm-7.122-2.72c-4.36 0-7.9 3.54-7.9 7.9s3.54 7.9 7.9 7.9c2.158 0 4.1-.864 5.525-2.245a5.53 5.53 0 01-3.928-5.31c0-2.676 1.9-4.92 4.446-5.438-1.468-1.684-3.626-2.806-6.043-2.806zM4.79 21.583A11.958 11.958 0 010 12C0 5.353 5.396 0 12 0s12 5.396 12 12-5.396 12-12 12c-1.554 0-3.022-.302-4.36-.82-1.079-.389-2.028-.907-2.849-1.597zm12.777-1.51a4.827 4.827 0 004.835-4.835 4.827 4.827 0 00-4.835-4.834 4.827 4.827 0 00-4.834 4.834 4.827 4.827 0 004.834 4.835Z" />
                                                </svg>
                                            </span>
                                            <span v-else-if="gate.slug === 'gerencia-net'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z" />
                                                </svg>
                                            </span>
                                            <span v-else-if="gate.slug === 'deposito'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 16 16">
                                                    <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                                    <path
                                                        d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z" />
                                                </svg>
                                            </span>
                                            <span v-else-if="gate.slug === 'dare'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z" />
                                                </svg>
                                            </span>
                                            <span v-else-if="gate.slug === 'stripe'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-stripe" viewBox="0 0 16 16">
                                                    <path
                                                        d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6.226 5.385c-.584 0-.937.164-.937.593 0 .468.607.674 1.36.93 1.228.415 2.844.963 2.851 2.993C11.5 11.868 9.924 13 7.63 13a7.7 7.7 0 0 1-3.009-.626V9.758c.926.506 2.095.88 3.01.88.617 0 1.058-.165 1.058-.671 0-.518-.658-.755-1.453-1.041C6.026 8.49 4.5 7.94 4.5 6.11 4.5 4.165 5.988 3 8.226 3a7.3 7.3 0 0 1 2.734.505v2.583c-.838-.45-1.896-.703-2.734-.703" />
                                                </svg>
                                            </span>
                                            <template>{{ gate.name }}</template>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-12 col-sm-12" v-if="showPaypalPaymentMessage"
                                    ref="paypal">
                                    <div class="paypal-card">
                                        <div class="paypal-card-title">
                                            <h3>{{ this.gateway.name }}</h3>
                                        </div>
                                        <div class="paypal-card-body">
                                            <p>
                                                {{ $t('cart.paypal_message') }}
                                            </p>
                                            <p>
                                                <strong>{{ $t('cart.obs') }}</strong> {{ $t('cart.paypal_obs') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 col-sm-12" v-if="showPagseguroPayment" ref="pagseguro">
                                    <div v-if="isSinushub"
                                        class="alert alert-warning d-flex align-items-center justify-content-center"
                                        role="alert">
                                        <p>Caso queira efetuar o pagamento via cartão de crédito, boleto ou Google
                                            Pay, clique na opção acima "Stripe"</p>

                                    </div>
                                    <change-payment-pag-seguro ref="pagSeguroPayment"
                                        @activateOption="activateOption" @cardInfoChanged="emitedCardInfoChanged"
                                        @fieldsNotValid="areFieldsNotValid" :selected="selected" :gateway="gateway"
                                        :pagseguroCreditCardOption="pagseguroCreditCardOption" />
                                </div>
                                <div class="col-12 col-md-12 col-sm-12" v-if="showBilletPaymentMessage"
                                    ref="billet">
                                    <div class="billet-card">
                                        <div class="billet-card-title">
                                            <h3>{{ this.gateway.name }}</h3>
                                        </div>
                                        <div class="billet-card-body">
                                            <p>
                                                {{ $t('cart.billet_bank') }}{{ this.gateway.name }}, {{
                                                    $t('cart.billet_bank_redirect') }}
                                            </p>
                                            <p>
                                                <strong>{{ $t('cart.obs') }}</strong> {{ $t('cart.obs_message') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 col-sm-12" v-else-if="showCreditCardPayment"
                                    ref="creditCard">
                                    <div class="paypal-card">
                                        <div class="paypal-card-title">
                                            <h3>{{ this.gateway.name }}</h3>
                                        </div>
                                        <div v-if="gateway && gateway.installments" class="paypal-card-body">
                                            <p>
                                                {{ $t('cart.credit_card_installments_message') }}
                                            </p>
                                            <base-input :name="$t('cart.recurrence.credit_card_expiration_year')"
                                                :placeholder="$t('cart.recurrence.credit_card_expiration_year')"
                                                required class="col-12 col-md-12"
                                                title="Selecione o número de parcelas" type="select">
                                                <select class="form-control" data-toggle="select" v-model="selected"
                                                    v-if="gateway && gateway.slug === gateway.slug && !!gateway.installments"
                                                    title="Selecione o número de parcelas"
                                                    data-placeholder="Select a state"
                                                    style="border: 1px solid #000000; color: black;">
                                                    <option v-for="installment in gateway.installments.values"
                                                        :key="installment.key" :value="installment.key">
                                                        {{ printInstallment(installment,
                                                            gateway.installments.increase_installment) }}
                                                    </option>
                                                </select>
                                            </base-input>
                                            <p>
                                                <strong>{{ $t('cart.obs') }}</strong> {{ $t('cart.credit_card_obs')
                                                }}
                                            </p>
                                        </div>
                                        <div v-else class="paypal-card-body">
                                            <p>
                                                {{ $t('cart.credit_card_message') }}
                                            </p>
                                            <p>
                                                <strong>{{ $t('cart.obs') }}</strong> {{ $t('cart.credit_card_obs')
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 col-sm-12" v-if="showDepositPaymentMessage"
                                    ref="deposit">
                                    <div class="billet-card">
                                        <div class="billet-card-title">
                                            <h3>{{ $t('cart.deposit') }}</h3>
                                        </div>
                                        <div class="billet-card-body">
                                            <p>
                                                {{ $t('cart.deposit_message') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 col-sm-12" v-if="showDarePaymentMessage" ref="dare">
                                    <div class="billet-card">
                                        <div class="billet-card-title">
                                            <h3>{{ this.gateway.name }}</h3>
                                        </div>
                                        <div class="billet-card-body">
                                            <p>
                                                {{ $t('cart.billet_dare') }}
                                            </p>
                                            <p>
                                                <strong>{{ $t('cart.obs') }}</strong> {{ $t('cart.obs_message') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 col-sm-12" v-if="showStripePayment" ref="stripe">
                                    <div class="paypal-card">
                                        <div class="paypal-card-title">
                                            <h3>{{ this.gateway.name }}</h3>
                                        </div>
                                        <div v-if="isSinushub"
                                            class="alert alert-warning d-flex align-items-center justify-content-center"
                                            role="alert">
                                            <p>Caso queira efeturar o pagamento via PIX, clique na opção acima
                                                "PagSeguro"</p>
                                        </div>
                                        <div
                                            v-if="this.plans[0].recurrenceOptions && this.plans[0].recurrenceOptions.length > 0">
                                            <ChangePaymentStripe />
                                        </div>
                                        <div class="paypal-card-body" v-else>
                                            <p>
                                                {{ $t('cart.stripe_message') }}
                                            </p>
                                            <p>
                                                <strong>{{ $t('cart.obs') }}</strong> {{ $t('cart.stripe_obs') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="this.plans[0].type === 4 && showPagseguroPayment && pagSeguroSelectPayment === 'CreditCard'"
                                class="phone-container">
                                <div>
                                    <h2 class="phone-title">{{ $t('cart.recurrence.recurrence') }}</h2>
                                </div>
                                <div class="birthdate-input">
                                    <input v-model="birthdate"
                                        :class="invalidBirthdate ? 'birthdate-input-form-invalid' : 'birthdate-input-form'"
                                        v-mask="'##/##/####'" placeholder="dd/mm/aaaa" tyoe="text"
                                        @input="validateBirthDate">
                                    <span class="invalidField" v-if="invalidBirthdate">
                                        {{ $t('cart.recurrence.invalid_birthdate') }}
                                    </span>
                                </div>
                                <div class="phone-input-container">
                                    <div class="phone-input-code">
                                        <input v-model="countryCode" class="phone-input-form" placeholder="55" required
                                            v-mask="'##'" type="text">
                                    </div>
                                    <div class="phone-input-ddd">
                                        <input v-model="phoneDdd" class="phone-input-form" placeholder="(xx)" required
                                            v-mask="'(##)'" type="text">
                                    </div>
                                    <div class="phone-input-number">
                                        <input v-model="phoneNumber"
                                            :class="invalidPhoneNumber ? 'phone-input-form-invalid' : 'phone-input-form'"
                                            placeholder="xxxxx-xxxx" required v-mask="'#####-####'" type="text"
                                            @input="validatePhoneNumber">
                                        <span class="invalidField" v-if="invalidPhoneNumber">
                                            {{ $t('cart.recurrence.invalid_phone_number') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="showPagseguroPayment" class="address-container">
                                <div>
                                    <h2 class="address-title">{{ $t('cart.address.address') }}</h2>
                                </div>
                                <div class="col-12 col-md-12 address-boxes">
                                    <div v-for="(address, i) in addresses" :key="address.id">
                                        <modal v-model:show="editStates[address.id]">
                                            <address-form v-if="edit && addressId === address.id" v-model="addresses[i]"
                                                :searchAddressByApi="false" />
                                            <base-input :name="'name'" type="text" :placeholder="'Tipo de endereço'"
                                                v-model="addresses[i].name" />
                                            <base-button type="danger" @click="closeAddressModal(address)">
                                                {{ $t('common.close') }}
                                            </base-button>
                                            <base-button type="success" @click="saveAddress(addresses[i])">
                                                {{ $t('common.save') }}
                                            </base-button>
                                        </modal>
                                        <card class="address-card">
                                            <div class="address-input">
                                                <input type="radio" :value="address.id" v-model="addressId">
                                            </div>

                                            <div class="edit-icon" @click="editAddress(address.id)">
                                                <i class="mdi mdi-pencil"></i>
                                            </div>
                                            <h3>{{ address.name }}</h3>
                                            <b>{{ $t('common.location.zip_code') }}: </b>
                                            <span>{{ address.location.zip }}</span>
                                            <br />
                                            <b>{{ $t('common.location.neighborhood') }}: </b>
                                            <span>{{ address.location.neighborhood }}</span>
                                            <br />
                                            <b>{{ $t('common.location.address') }}: </b> <span>{{
                                                address.location.address
                                            }},
                                                {{ address.location.number }}</span>
                                            <br />
                                            <span v-if="address.location.info">
                                                <b>{{ $t('common.location.info') }}: </b>
                                                <span>{{ address.location.info }}</span>
                                                <br />
                                            </span>
                                        </card>
                                    </div>
                                    <div class="add-address">
                                        <base-button class="add-address-buttom" block @click="isLogged">
                                            <i class="material-icons">add</i>
                                        </base-button>
                                    </div>
                                </div>
                            </div>
                            <div class="payment-details">
                                <h2>Detalhes da compra</h2>
                                <div class="details-box">
                                    <div class="">
                                        <div class="d-flex justify-content-between">
                                            <h3 class="hidden-xs text-left">
                                                {{ $t('cart.total') }}
                                            </h3>
                                            <h3 class="custom-spacing">{{ formatValue(total) }}</h3>
                                        </div>
                                    </div>
                                    <template v-if="true">
                                        <div class="">
                                            <h3 class="mt-2" v-if="gateway.currencies.length > 1">
                                                {{ $t('cart.currency') }}
                                            </h3>
                                            <div class="control ml-4" v-if="gateway.currencies.length > 1">
                                                <div v-for="code in gateway.currencies" :key="code"
                                                    class="custom-control custom-radio">
                                                    <input type="radio" v-model="currency" :value="code" :id="code"
                                                        :name="$t('cart.currency')" class="custom-control-input"
                                                        v-validate="'required'" />
                                                    <label class="custom-control-label" :for="code">{{ code }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <template v-if="pagSeguroFinishPayment === true">
                    <div class="thank-you-message">
                        <i class="fa fa-check-circle"></i>
                        <span class="thank-you-description">{{ $t('cart.finish_payment') }}</span>
                        <span class="thank-you-plan-activate">{{ $t('cart.plan_activate') }}</span>
                        <div class="mt-3">
                            <button @click="proceedToPlans" class="btn btn-success btn-block plans-btn">
                                {{ $t('common.plans') }}
                            </button>
                        </div>
                    </div>
                </template>
                <template v-if="pagSeguroFinishPaymentPix === true">
                    <div class="pix-card">
                        <div class="left-content">
                            <h2>{{ $t('cart.pix_key') }}</h2>
                            <p>{{ $t('cart.pix_copy') }}</p>
                            <div class="input-container">
                                <input type="text" v-model="pix[0].text" readonly ref="pixInput" />
                                <div class="copy-icon" @click="copyToClipboard">
                                    <i class="fas fa-copy"></i>
                                </div>
                            </div>
                        </div>
                        <div class="divider"></div>
                        <div class="right-content">
                            <div class="qrcode">
                                <img :src="pix[0].links[0].href" alt="">
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="pagSeguroFinishPaymentBillet === true">
                    <div>
                        <div class="save-billet">
                            <base-button class="btn btn-success btn-block save-billet-button"
                                @click="savePdfBillet"><span class="save-billet-text">{{ $t('cart.pagseguro_billet_pdf')
                                }}</span><i class="material-icons save-billet-icon">save_alt</i>
                            </base-button>
                        </div>
                        <div>
                            <img :src="this.billet[1].href" alt="">
                        </div>
                    </div>
                </template>

                <div v-if="showCreditCardPayment" class="cart-checkout col-12 col-md-3 mt-5">
                    <button @click="proceedCheckout" class="btn btn-success btn-block" :disabled="disabled">
                        {{ total > 0 ? $t('cart.make_payment') + $t('cart.credit_card') : $t('cart.subscribe') }}
                    </button>
                </div>
                <div v-if="showPaypalPaymentMessage" class="cart-checkout-paypal col-12 col-md-5 mt-3">
                    <button @click="proceedCheckout" class="btn btn-block" :disabled="disabled">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <path
                                d="M14.06 3.713c.12-1.071-.093-1.832-.702-2.526C12.628.356 11.312 0 9.626 0H4.734a.7.7 0 0 0-.691.59L2.005 13.509a.42.42 0 0 0 .415.486h2.756l-.202 1.28a.628.628 0 0 0 .62.726H8.14c.429 0 .793-.31.862-.731l.025-.13.48-3.043.03-.164.001-.007a.351.351 0 0 1 .348-.297h.38c1.266 0 2.425-.256 3.345-.91.379-.27.712-.603.993-1.005a4.942 4.942 0 0 0 .88-2.195c.242-1.246.13-2.356-.57-3.154a2.687 2.687 0 0 0-.76-.59l-.094-.061ZM6.543 8.82a.695.695 0 0 1 .321-.079H8.3c2.82 0 5.027-1.144 5.672-4.456l.003-.016c.217.124.4.27.548.438.546.623.679 1.535.45 2.71-.272 1.397-.866 2.307-1.663 2.874-.802.57-1.842.815-3.043.815h-.38a.873.873 0 0 0-.863.734l-.03.164-.48 3.043-.024.13-.001.004a.352.352 0 0 1-.348.296H5.595a.106.106 0 0 1-.105-.123l.208-1.32.845-5.214Z" />
                        </svg>
                        {{ total > 0 ? $t('cart.make_payment') + $t('cart.paypal') : $t('cart.subscribe') }}
                    </button>
                </div>
                <div v-if="showPagseguroPayment && pagSeguroFinishPayment === false && pagSeguroSelectPayment === 'CreditCard'"
                    class="cart-checkout-pagseguro col-12 col-md-5 mt-3">
                    <button @click="proceedCheckoutPagSeguro" class="btn btn-block" :disabled="disabled">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                            <path
                                d="M17.482 9.712c1.64 0 3.108.69 4.1 1.813.044-.388.087-.777.087-1.208C21.67 5.007 17.353.69 12 .69c-5.353 0-9.67 4.316-9.67 9.626 0 .345 0 .69.044 1.036a8.688 8.688 0 017.943-5.137c2.848 0 5.352 1.381 6.95 3.496h.215zm-7.122-2.72c-4.36 0-7.9 3.54-7.9 7.9s3.54 7.9 7.9 7.9c2.158 0 4.1-.864 5.525-2.245a5.53 5.53 0 01-3.928-5.31c0-2.676 1.9-4.92 4.446-5.438-1.468-1.684-3.626-2.806-6.043-2.806zM4.79 21.583A11.958 11.958 0 010 12C0 5.353 5.396 0 12 0s12 5.396 12 12-5.396 12-12 12c-1.554 0-3.022-.302-4.36-.82-1.079-.389-2.028-.907-2.849-1.597zm12.777-1.51a4.827 4.827 0 004.835-4.835 4.827 4.827 0 00-4.835-4.834 4.827 4.827 0 00-4.834 4.834 4.827 4.827 0 004.834 4.835Z" />
                        </svg>
                        {{ total > 0 ? $t('cart.make_payment') + $t('cart.pagseguro') : $t('cart.subscribe') }}
                    </button>
                </div>
                <div v-if="showPagseguroPayment && pagSeguroFinishPaymentPix === false && pagSeguroSelectPayment === 'Pix'"
                    class="cart-checkout-pagseguro col-12 col-md-5 mt-3">
                    <button @click="proceedCheckoutPagSeguro" class="btn btn-block" :disabled="disabled">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                            <path
                                d="M17.482 9.712c1.64 0 3.108.69 4.1 1.813.044-.388.087-.777.087-1.208C21.67 5.007 17.353.69 12 .69c-5.353 0-9.67 4.316-9.67 9.626 0 .345 0 .69.044 1.036a8.688 8.688 0 017.943-5.137c2.848 0 5.352 1.381 6.95 3.496h.215zm-7.122-2.72c-4.36 0-7.9 3.54-7.9 7.9s3.54 7.9 7.9 7.9c2.158 0 4.1-.864 5.525-2.245a5.53 5.53 0 01-3.928-5.31c0-2.676 1.9-4.92 4.446-5.438-1.468-1.684-3.626-2.806-6.043-2.806zM4.79 21.583A11.958 11.958 0 010 12C0 5.353 5.396 0 12 0s12 5.396 12 12-5.396 12-12 12c-1.554 0-3.022-.302-4.36-.82-1.079-.389-2.028-.907-2.849-1.597zm12.777-1.51a4.827 4.827 0 004.835-4.835 4.827 4.827 0 00-4.835-4.834 4.827 4.827 0 00-4.834 4.834 4.827 4.827 0 004.834 4.835Z" />
                        </svg>
                        Gerar QR Code
                    </button>
                </div>
                <div v-if="showPagseguroPayment && pagSeguroFinishPaymentBillet === false && pagSeguroSelectPayment === 'Boleto'"
                    class="cart-checkout-pagseguro col-12 col-md-5 mt-3">
                    <button @click="proceedCheckoutPagSeguro" class="btn btn-block" :disabled="disabled">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                            <path
                                d="M17.482 9.712c1.64 0 3.108.69 4.1 1.813.044-.388.087-.777.087-1.208C21.67 5.007 17.353.69 12 .69c-5.353 0-9.67 4.316-9.67 9.626 0 .345 0 .69.044 1.036a8.688 8.688 0 017.943-5.137c2.848 0 5.352 1.381 6.95 3.496h.215zm-7.122-2.72c-4.36 0-7.9 3.54-7.9 7.9s3.54 7.9 7.9 7.9c2.158 0 4.1-.864 5.525-2.245a5.53 5.53 0 01-3.928-5.31c0-2.676 1.9-4.92 4.446-5.438-1.468-1.684-3.626-2.806-6.043-2.806zM4.79 21.583A11.958 11.958 0 010 12C0 5.353 5.396 0 12 0s12 5.396 12 12-5.396 12-12 12c-1.554 0-3.022-.302-4.36-.82-1.079-.389-2.028-.907-2.849-1.597zm12.777-1.51a4.827 4.827 0 004.835-4.835 4.827 4.827 0 00-4.835-4.834 4.827 4.827 0 00-4.834 4.834 4.827 4.827 0 004.834 4.835Z" />
                        </svg>
                        {{ $t('cart.pagseguro_billet_generate') }}
                    </button>
                </div>
                <div v-if="showBilletPaymentMessage" class="cart-checkout col-12 col-md-5 mt-3">
                    <button @click="proceedCheckout" class="btn btn-success btn-block" :disabled="disabled">
                        {{ total > 0 ? $t('cart.make_payment') + this.gateway.name : $t('cart.subscribe') }}
                    </button>
                </div>
                <div v-if="showDepositPaymentMessage" class="cart-checkout col-12 col-md-5 mt-3">
                    <button @click="proceedCheckout" class="btn btn-success btn-block" :disabled="disabled">
                        {{ total > 0 ? $t('cart.make_payment') + $t('cart.deposit') : $t('cart.subscribe') }}
                    </button>
                </div>
                <div v-if="showDarePaymentMessage" class="cart-checkout col-12 col-md-5 mt-3">
                    <button @click="proceedCheckout" class="btn btn-success btn-block" :disabled="disabled">
                        {{ total > 0 ? $t('cart.make_payment') + $t('cart.dare') : $t('cart.subscribe') }}
                    </button>
                </div>
                <div v-if="showStripePayment" class="cart-checkout col-12 col-md-5 mt-3">
                    <div v-if="this.plans[0].recurrenceOptions && this.plans[0].recurrenceOptions.length > 0">
                        <button @click="proceedCheckout" class="btn btn-success btn-block" :disabled="disabled">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-stripe" viewBox="0 0 16 16">
                                <path
                                    d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6.226 5.385c-.584 0-.937.164-.937.593 0 .468.607.674 1.36.93 1.228.415 2.844.963 2.851 2.993C11.5 11.868 9.924 13 7.63 13a7.7 7.7 0 0 1-3.009-.626V9.758c.926.506 2.095.88 3.01.88.617 0 1.058-.165 1.058-.671 0-.518-.658-.755-1.453-1.041C6.026 8.49 4.5 7.94 4.5 6.11 4.5 4.165 5.988 3 8.226 3a7.3 7.3 0 0 1 2.734.505v2.583c-.838-.45-1.896-.703-2.734-.703" />
                            </svg>
                            {{ total > 0 ? $t('cart.make_payment') + $t('cart.payment_intent_stripe') :
                                $t('cart.subscribe') }}
                        </button>
                    </div>
                    <div v-else>
                        <button @click="proceedCheckout" class="btn btn-success btn-block" :disabled="disabled">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-stripe" viewBox="0 0 16 16">
                                <path
                                    d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6.226 5.385c-.584 0-.937.164-.937.593 0 .468.607.674 1.36.93 1.228.415 2.844.963 2.851 2.993C11.5 11.868 9.924 13 7.63 13a7.7 7.7 0 0 1-3.009-.626V9.758c.926.506 2.095.88 3.01.88.617 0 1.058-.165 1.058-.671 0-.518-.658-.755-1.453-1.041C6.026 8.49 4.5 7.94 4.5 6.11 4.5 4.165 5.988 3 8.226 3a7.3 7.3 0 0 1 2.734.505v2.583c-.838-.45-1.896-.703-2.734-.703" />
                            </svg>
                            {{ total > 0 ? $t('cart.make_payment') + $t('cart.checkout_stripe') : $t('cart.subscribe')
                            }}
                        </button>
                    </div>
                </div>
            </card>
            <CartEmpty v-else />
        </div>

        <modal v-model:show="newAddress">
            <AddressForm v-if="newAddress" v-model="address" />
            <base-input :name="'name'" type="text" :placeholder="'Tipo de endereço'" v-model="address.name" />
            <base-button block type="success" @click="saveNewAddress">{{ $t('common.save') }}</base-button>
        </modal>

        <loading-spinner class="spinner-loading" v-if="finishLoading"></loading-spinner>
    </div>
</template>

<script>
import CartItem from './CartComponents/CartItem';
import Card from '../argon/components/Cards/Card';
import CartEmpty from '../components/CartComponents/CartEmpty';
import BaseInput from '../argon/components/Inputs/BaseInput';
import BaseButton from '../argon/components/BaseButton';

import Currency from '../mixins/currency';
import ChangePaymentCreditCard from './CheckoutComponents/ChangePaymentCreditCard.vue';
import ChangePaymentPagSeguro from './CheckoutComponents/ChangePaymentPagSeguro.vue';
import ChangePaymentStripe from './CheckoutComponents/ChangePaymentStripe.vue';
import ProfileAddresses from '../components/ProfileComponents/ProfileAddresses';
import AddressForm from '../components/FormBuilderComponents/ContentComponents/AddressForm';
import modal from '../argon/components/Modal.vue';

import LoadingSpinner from './Common/LoadingSpinner.vue'

import axios from 'axios';

export default {
    name: 'Cart',

    components: {
        CartEmpty,
        CartItem,
        Card,
        BaseInput,
        BaseButton,
        ChangePaymentCreditCard,
        ChangePaymentPagSeguro,
        ChangePaymentStripe,
        LoadingSpinner,
        ProfileAddresses,
        AddressForm,
        modal
    },

    props: {
        gateways: {
            type: Array,
            required: true,
        },

        user: {
            type: Object,
            required: false,
        },

        has_coupon: {
            type: Boolean,
            required: true,
        },

        invoice_id: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            currency: 'BRL',
            gateway: {
                currencies: [],
            },
            loaded: false,
            disabled: false,
            selected: 1,
            activeButtonIndex: null,
            showPagseguroPayment: false,
            showStripePayment: false,
            showCreditCardPayment: false,
            showDepositPayment: false,
            pagseguroCardInfo: {},
            encrypted: '',
            showPaypalPaymentMessage: false,
            showBilletPaymentMessage: false,
            showDarePaymentMessage: false,
            showDepositPaymentMessage: false,
            showPagSeguroPaymentMessage: false,
            finishLoading: false,
            pagSeguroFinishPayment: false,
            pagSeguroFinishPaymentPix: false,
            pagSeguroFinishPaymentBillet: false,
            stripeFastCheckout: true,
            fieldsValid: '',
            pagSeguroSelectPayment: '',
            addresses: [],
            address: {
                name: '',
                location: {
                    zip: '',
                    address: '',
                    number: '',
                    neighborhood: '',
                    country: '',
                    state: '',
                    city: '',
                    info: '',
                },
            },
            newAddress: false,
            edit: false,
            editStates: {},
            addressId: null,
            pix: {},
            billet: {},
            countryCode: '55',
            phoneDdd: '',
            phoneNumber: '',
            invalidPhoneNumber: false,
            phoneHolder: {},
            cardFlag: '',
            birthdate: '',
            invalidBirthdate: false,
            phoneNBirth: true,
        };
    },

    mixins: [Currency],

    created() {
        this.gateway = {
            currencies: [],
        };
        //check if the fast checkout is enabled
        this.isFastCheckout();
    },
    watch: {
        currency(newVal, oldVal) {
            this.saveCartOptions('currency', newVal);
            if (newVal && newVal !== oldVal) {
                this.$store.dispatch('CHANGE_CURRENCY', {
                    code: newVal,
                });
                this.getPlans();
            }
        },

        gateway(value) {
            this.selected = 1;
            this.selectedPayment(value);
            this.saveCartOptions('gateway', value);
        },

        selected(val) {
            const installment = this.gateway.installments.values.find(
                obj => { return obj.key === val; }
            );
            if (installment.value !== this.total) {
                this.$store.commit('SET_CART', {
                    total:installment.value,
                    plans:this.plans,
                    currency:this.$store.getters.CART.currency
                });
            }
        },

        message: {
            deep: true,
            handler(value) {
                if (value.type === 0) {
                    this.$notify({
                        type: 'success',
                        message: value.text,
                    });
                } else {
                    this.$notify({
                        type: 'danger',
                        message: value.text,
                    });
                }
            },
        },
    },

    methods: {
        isFastCheckout() {
            window.axios.get('/api/is-fast-checkout', {
                headers: {
                    Authorization: `Bearer ${this.$store.getters.TOKEN}`,
                },
            }).then((response) => {
                this.stripeFastCheckout = response.data.fastCheckout;
            })
            .catch((err) => {
                this.stripeFastCheckout = false;
            });
        },
        validateBirthDate() {
            const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
            const currentDate = new Date();
            const selectedDate = new Date(this.birthdate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));

            if (!dateRegex.test(this.birthdate) || selectedDate > currentDate) {
                this.invalidBirthdate = true;
            } else {
                this.invalidBirthdate = false;
                this.phoneNBirth = false;
            }
        },
        isLogged() {
            this.isFastCheckout();
            if (!this.user || this.$store.getters.USER.public) {
                if(!this.stripeFastCheckout){
                    this.$store.commit('DIALOG_SHOW', {
                        redirect: 'cart',
                    });
                }
            } else {
                this.newAddress = true;
            }
        },

        validatePhoneNumber() {
            const phoneRegex = /^\d{5}-\d{4}$/;

            // Verifica se o número de telefone tem o formato esperado
            if (phoneRegex.test(this.phoneNumber)) {
                this.invalidPhoneNumber = false;
            } else {
                this.invalidPhoneNumber = true;
                this.phoneNBirth = false;
            }
        },

        savePdfBillet() {
            const pdfLink = this.billet[0].href;

            if (pdfLink) {
                window.open(pdfLink, '_blank');
            }
        },

        copyToClipboard() {
            const input = this.$refs.pixInput;
            input.select();
            document.execCommand('copy');

            this.$notify({
                type: 'success',
                message: 'Texto copiado para a área de transferência!',
            })
        },
        async saveAddress(data) {
            this.$loading.show();
            await window.axios
                .put(`/api/app/addresses/update/${data.id}`, {
                    ...data,
                })
                .then((res) => {
                    this.$notify({
                        type: 'success',
                        message: res.data.message,
                    });
                    this.editStates[data.id] = false;
                    this.edit = false;
                    this.getAddresses();
                })
                .catch((err) => {
                    const errors = err.response.data.errors;

                    for (const key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            const errorMessages = errors[key];

                            errorMessages.forEach(errorMessage => {
                                this.$notify({
                                    type: 'danger',
                                    message: errorMessage,
                                });
                            });
                        }
                    }
                })
                .finally(() => this.$loading.close());
        },

        editAddress(id) {
            this.editStates[id] = !this.editStates[id];
            this.addressId = id;
            this.edit = true;
        },

        activateOption(option) {
            if (option === 'CreditCard') {
                this.pagSeguroSelectPayment = 'CreditCard';
                event.preventDefault();
                this.$refs.pagseguro.scrollIntoView({ behavior: 'smooth' });
            } else if (option === 'Pix') {
                this.pagSeguroSelectPayment = 'Pix';
                event.preventDefault();
                this.$refs.pagseguro.scrollIntoView({ behavior: 'smooth' });
            } else if (option === 'Boleto') {
                this.pagSeguroSelectPayment = 'Boleto';
                event.preventDefault();
                this.$refs.pagseguro.scrollIntoView({ behavior: 'smooth' });
            }
        },

        emitedCardInfoChanged(cardInfo) {
            this.pagseguroCardInfo = cardInfo;
        },

        areFieldsNotValid(valid) {
            this.fieldsValid = valid;
        },

        pagSeguroEncrypted() {
            const card = PagSeguro.encryptCard({
                publicKey: this.gateway.public_key,
                holder: this.pagseguroCardInfo.cardHolderName,
                number: this.pagseguroCardInfo.cardNumber,
                expMonth: this.pagseguroCardInfo.cardExpirationMonth,
                expYear: this.pagseguroCardInfo.cardExpirationYear,
                securityCode: this.pagseguroCardInfo.cardCvv,
            });

            this.encrypted = card.encryptedCard;
        },
        selectedPayment(value) {
            if (!this.user || this.$store.getters.USER.public) {
                if(!this.stripeFastCheckout){
                    this.$store.commit('DIALOG_SHOW', {
                        redirect: 'cart',
                    });
                }
            }
            if (value.name === 'Pagseguro') {
                if (value.payment_methods.credit_card === true) {
                    this.pagSeguroSelectPayment = 'CreditCard'
                } else if (value.payment_methods.pix === true) {
                    this.pagSeguroSelectPayment = 'Pix'
                } else if (value.payment_methods.billet === true) {
                    this.pagSeguroSelectPayment = 'Boleto'
                }
                this.showPagseguroPayment = true;
                this.$nextTick(() => {
                    this.$refs.pagseguro.scrollIntoView({ behavior: 'smooth' });
                });
                this.showPaypalPaymentMessage = false;
                this.showBilletPaymentMessage = false;
                this.showDarePaymentMessage = false;
                this.showDepositPaymentMessage = false;
                this.showCreditCardPayment = false;
                this.showStripePayment = false;
            } else if (value.name === 'Crédito / Débito') {
                this.showCreditCardPayment = true;
                this.$nextTick(() => {
                    this.$refs.creditCard.scrollIntoView({ behavior: 'smooth' });
                });
                this.showPaypalPaymentMessage = false;
                this.showBilletPaymentMessage = false;
                this.showDarePaymentMessage = false;
                this.showDepositPaymentMessage = false;
                this.showPagseguroPayment = false;
                this.showStripePayment = false;
            } else if (value.name === 'Paypal') {
                this.showPaypalPaymentMessage = true;
                this.$nextTick(() => {
                    this.$refs.paypal.scrollIntoView({ behavior: 'smooth' });
                });
                this.showPagseguroPayment = false;
                this.showCreditCardPayment = false;
                this.showBilletPaymentMessage = false;
                this.showDarePaymentMessage = false;
                this.showDepositPaymentMessage = false;
                this.showStripePayment = false;
            } else if (value.name === 'Santander' || value.name === 'Banco do Brasil' || value.name === 'Caixa Econômica' || value.name === 'Itaú' || value.name === 'Bradesco') {
                this.showBilletPaymentMessage = true;
                this.$nextTick(() => {
                    this.$refs.billet.scrollIntoView({ behavior: 'smooth' });
                });
                this.showPagseguroPayment = false;
                this.showCreditCardPayment = false;
                this.showPaypalPaymentMessage = false;
                this.showDarePaymentMessage = false;
                this.showDepositPaymentMessage = false;
                this.showStripePayment = false;
            } else if (value.name === 'Dare') {
                this.showDarePaymentMessage = true;
                this.$nextTick(() => {
                    this.$refs.dare.scrollIntoView({ behavior: 'smooth' });
                });
                this.showPagseguroPayment = false;
                this.showCreditCardPayment = false;
                this.showPaypalPaymentMessage = false;
                this.showBilletPaymentMessage = false;
                this.showDepositPaymentMessage = false;
                this.showStripePayment = false;
            } else if (value.name === 'Deposito') {
                this.showDepositPaymentMessage = true;
                this.$nextTick(() => {
                    this.$refs.deposit.scrollIntoView({ behavior: 'smooth' });
                });
                this.showPagseguroPayment = false;
                this.showCreditCardPayment = false;
                this.showPaypalPaymentMessage = false;
                this.showBilletPaymentMessage = false;
                this.showDarePaymentMessage = false;
                this.showStripePayment = false;
            }else if (value.name === 'Stripe') {
                this.showStripePayment = true;
                this.$nextTick(() => {
                    this.$refs.stripe.scrollIntoView({ behavior: 'smooth' });
                });
                this.showPagseguroPayment = false;
                this.showCreditCardPayment = false;
                this.showPaypalPaymentMessage = false;
                this.showBilletPaymentMessage = false;
                this.showDarePaymentMessage = false;
                this.showDepositPaymentMessage = false;
            } else {
                this.showPagseguroPayment = false;
                this.showCreditCardPayment = false;
                this.showPaypalPaymentMessage = false;
                this.showBilletPaymentMessage = false;
                this.showDarePaymentMessage = false;
                this.showDepositPaymentMessage = false;
                this.showStripePayment = false;
            }
        },
        async getPlans() {
            this.$loading.show();
            await this.$store.dispatch('GET_CART', {
                currency: this.currency,
                invoice_id: this.invoice_id
            });
            this.loaded = true;
            this.$loading.close();
        },

        getCartOptions(key = false) {
            const storage = localStorage.getItem('CART');
            const cart = storage ? JSON.parse(storage) : {};
            return key ? cart[key] : cart;
        },

        saveCartOptions(key, value) {
            const storage = localStorage.getItem('CART');
            const cart = storage ? JSON.parse(storage) : {};
            cart[key] = value;
            localStorage.setItem('CART', JSON.stringify(cart));
        },

        restoreOptions() {
            const savedGateway = this.getCartOptions('gateway');
            const gateway = this.gateways.find(({ slug }) => (
                savedGateway && savedGateway.slug === slug
            ));
            if (gateway) {
                this.gateway = gateway;
                const savedCurrency = this.getCartOptions('currency');
                const currency = gateway.currencies.find(item => (
                    item === savedCurrency
                ));
                if (currency) {
                    this.currency = currency;
                }
            }
        },

        proceedCheckoutPagSeguro() {
            this.$refs.pagSeguroPayment.validateFields();
            this.areFieldsNotValid();

            if (this.addressId != null) {
                setTimeout(() => {
                    if (this.pagSeguroSelectPayment === 'CreditCard' && this.fieldsValid === false) {
                        if (((this.invalidPhoneNumber === false && this.invalidBirthdate === false && this.phoneNBirth === false && this.plans[0].type === 4) && (!this.invoice_id))) {
                            this.phoneHolder = {
                                country: this.countryCode,
                                area: this.phoneDdd,
                                number: this.phoneNumber
                            };
                            setTimeout(() => {
                                this.pagSeguroEncrypted();
                                this.proceedCheckout();
                            }, 500);
                        } else if (this.plans[0].type === 4 && (!this.invoice_id)){
                            this.$notify({
                                type: 'danger',
                                message: this.$t('cart.recurrence.invalid_checkout'),
                            });
                            return ''
                        } else {
                            this.pagSeguroEncrypted();
                            this.proceedCheckout();
                        }
                    } else if (this.pagSeguroSelectPayment === 'Pix' && this.fieldsValid === false) {
                        this.proceedCheckout();
                    } else if (this.pagSeguroSelectPayment === 'Boleto' && this.fieldsValid === false) {
                        this.proceedCheckout();
                    }
                }, 500);
            } else {
                this.$notify({
                    type: 'danger',
                    message: this.$t('cart.address.insert'),
                });
            }
        },

        pagSeguroCardRecurrence() {
            const numeroLimpo = this.pagseguroCardInfo.cardNumber.replace(/\D/g, '');

            const regexVisa = /^4[0-9]{12}(?:[0-9]{3})?$/;
            const regexMastercard = /^5[1-5][0-9]{14}$/;
            const regexAmex = /^3[47][0-9]{13}$/;
            const regexDiscover = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
            const regexDiners = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/;
            const regexHipercard = /^(3841|6011)[0-9]{12}$/;
            const regexElo = /^((4312|4313|4314|4315|4316|5067|4576|4011|4012|4013|4014|4015|4016|5041|5043|4514|4576|6362|6363|6364|6365|6366|5067|4576)[0-9]|4576-6[0-9]|4576-60[0-9]|4576-60-1[0-9]|4576-60-20[0-9]|4576-60-21[0-8])[0-9]{10}$/;

            if (regexVisa.test(numeroLimpo)) {
                this.cardFlag = 'Visa';
            } else if (regexMastercard.test(numeroLimpo)) {
                this.cardFlag = 'Mastercard';
            } else if (regexAmex.test(numeroLimpo)) {
                this.cardFlag = 'American Express';
            } else if (regexDiscover.test(numeroLimpo)) {
                this.cardFlag = 'Discover';
            } else if (regexDiners.test(numeroLimpo)) {
                this.cardFlag = 'Diners';
            } else if (regexHipercard.test(numeroLimpo)) {
                this.cardFlag = 'Hipercard';
            } else if (regexElo.test(numeroLimpo)) {
                this.cardFlag = 'Elo';
            } else {
                this.cardFlag = 'Bandeira não reconhecida';
            }
        },

        proceedToPlans() {
            window.location.href = '/app/dashboard';
        },

        proceedCheckout() {
            if (!this.user || this.$store.getters.USER.public) {
                if (this.stripeFastCheckout && this.gateway.slug === 'stripe'){
                    window.axios
                    .post('/api/fast-checkout',{
                        plans: this.plans
                    }).then((res) => {
                        console.log(res);
                        window.location.href = res.data.url;
                    }).catch((err) => {
                        console.log(err);
                    });

                } else {
                    this.$store.commit('DIALOG_SHOW', {
                        redirect: 'cart',
                    });
                }
            } else if (this.user.roles.filter(role => (
                role.name === 'app'
            )).length <= 0) {
                this.$notify({
                    type: 'danger',
                    message: this.$t('cart.admin_message'),
                });
            } else {
                this.disabled = true;
                this.finishLoading = true;
                let [slug, bank] = this.gateway.slug.split('/');
                const installment = this.selected;
                const invoice = document.location.search.replace('?invoice=', '');
                if (this.gateway.slug === 'pagseguro' && this.pagSeguroSelectPayment === 'CreditCard') {
                    this.pagSeguroCardRecurrence();
                    if (this.plans[0].type === 4) {
                        window.axios
                        .post('/api/app/checkout/finish', {
                            slug,
                            bank,
                            installment,
                            invoice,
                            phone: this.phoneHolder,
                            payment_method: {
                                type: "CREDIT_CARD",
                                address: this.addressId,
                                installments: this.pagseguroCardInfo.installments,
                                capture: true,
                                document: this.pagseguroCardInfo.cardHolderCpf,
                                card: {
                                    cvv: this.pagseguroCardInfo.cardCvv,
                                    number: this.pagseguroCardInfo.cardNumber,
                                    expiration_month: this.pagseguroCardInfo.cardExpirationMonth,
                                    expiration_year: this.pagseguroCardInfo.cardExpirationYear,
                                    brand: this.cardFlag,
                                    store: false
                                },
                                holder: {
                                    name: this.pagseguroCardInfo.cardHolderName,
                                    document: this.pagseguroCardInfo.cardHolderCpf,
                                    birth_date: this.birthdate,
                                },
                            }
                        })
                        .then((res) => {
                            let url = res.data.url;
                            this.finishLoading = false;
                            if (res.data.installment) {
                                url += '?installment=' + res.data.installment;
                            }

                            if (this.gateway.slug === 'pagseguro') {
                                this.finishLoading = false;
                                return this.pagSeguroFinishPayment = true;
                            }
                        })
                        .catch((err) => {
                            this.$notify({
                                type: 'danger',
                                message: this.$t(err.response.data.error),
                            });
                            this.disabled = false;
                            this.finishLoading = false;
                        });
                    } else {
                        window.axios
                        .post('/api/app/checkout/finish', {
                            slug,
                            bank,
                            installment,
                            invoice,
                            payment_method: {
                                type: "CREDIT_CARD",
                                address: this.addressId,
                                installments: this.pagseguroCardInfo.installments,
                                capture: true,
                                card: {
                                    encrypted: this.encrypted,
                                    security_code: this.pagseguroCardInfo.cardCvv,
                                    holder: {
                                        name: this.pagseguroCardInfo.cardHolderName,
                                        document: this.pagseguroCardInfo.cardHolderCpf,
                                    },
                                    store: false
                                }
                            }
                        })
                        .then((res) => {
                            let url = res.data.url;
                            this.finishLoading = false;
                            if (res.data.installment) {
                                url += '?installment=' + res.data.installment;
                            }

                            if (this.gateway.slug === 'pagseguro') {
                                this.finishLoading = false;
                                return this.pagSeguroFinishPayment = true;
                            }
                        })
                        .catch((err) => {
                            this.$notify({
                                type: 'danger',
                                message: this.$t(err.response.data.error),
                            });
                            this.disabled = false;
                            this.finishLoading = false;
                        });
                    }
                } else if (this.gateway.slug === 'pagseguro' && this.pagSeguroSelectPayment === 'Pix') {
                    window.axios
                    .post('/api/app/checkout/finish', {
                        slug,
                        bank,
                        installment,
                        invoice,
                        payment_method: {
                            type: "PIX",
                            address: this.addressId,
                            capture: true,
                            document: this.pagseguroCardInfo.cardHolderCpf,
                        }
                    })
                    .then((res) => {
                        let url = res.data.url;
                        this.finishLoading = false;
                        if (res.data.installment) {
                            url += '?installment=' + res.data.installment;
                        }

                        if (this.gateway.slug === 'pagseguro') {
                            this.finishLoading = false;
                            this.pix = res.data.qr_codes;
                            return this.pagSeguroFinishPaymentPix = true;
                        }
                    })
                    .catch((err) => {
                        this.$notify({
                            type: 'danger',
                            message: this.$t(err.response.data.error),
                        });
                        this.disabled = false;
                        this.finishLoading = false;
                    });
                } else if (this.gateway.slug === 'pagseguro' && this.pagSeguroSelectPayment === 'Boleto') {
                    window.axios
                    .post('/api/app/checkout/finish', {
                        slug,
                        bank,
                        installment,
                        invoice,
                        payment_method: {
                            type: "BOLETO",
                            address: this.addressId,
                            capture: true,
                            document: this.pagseguroCardInfo.cardHolderCpf,
                        }
                    })
                    .then((res) => {
                        let url = res.data.url;
                        // this.finishLoading = false;
                        if (res.data.installment) {
                            url += '?installment=' + res.data.installment;
                        }

                        if (this.gateway.slug === 'pagseguro') {
                            this.finishLoading = false;
                            this.billet = res.data.links;
                            return this.pagSeguroFinishPaymentBillet = true;
                        }

                        if (this.gateway.slug !== 'pagseguro') {
                            this.finishLoading = false;
                            location.href = url;
                        }
                    })
                    .catch((err) => {
                        this.$notify({
                            type: 'danger',
                            message: this.$t(err.response.data.error),
                        });
                        this.disabled = false;
                        this.finishLoading = false;
                    });
                } else if (this.gateway.slug === 'stripe') {
                    this.$loading.show();
                    window.axios
                    .post('/api/app/checkout/finish', {
                        slug,
                        bank,
                        installment,
                        invoice,
                    })
                    .then((res) => {
                        let url = res.data.url;
                        this.finishLoading = false;
                        if (res.data.installment) {
                            url += '?installment=' + res.data.installment;
                        }
                        location.href = url;
                    })
                    .catch((err) => {
                        this.$notify({
                            type: 'danger',
                            message: this.$t(err.response.data.error),
                        });
                        this.disabled = false;
                        this.finishLoading = false;
                    });
                } else {
                    window.axios
                        .post('/api/app/checkout/finish', {
                            slug,
                            bank,
                            installment,
                            invoice,
                        })
                        .then((res) => {
                            let url = res.data.url;
                            this.finishLoading = false;
                            if (res.data.installment) {
                                url += '?installment=' + res.data.installment;
                            }
                            location.href = url;
                        })
                        .catch((err) => {
                            this.$notify({
                                type: 'danger',
                                message: this.$t(err.response.data.error),
                            });
                            this.disabled = false;
                            this.finishLoading = false;
                        });
                }
                const payment = this.errors.first(this.$t('cart.payment_type'));
                const currency = this.errors.first(this.$t('cart.currency'));
                if (payment) {
                    this.$notify({
                        type: 'danger',
                        message: payment,
                    });
                }
                if (currency) {
                    this.$notify({
                        type: 'danger',
                        message: currency,
                    });
                }

                this.$loading.close();
            }
        },

        printInstallment(installment, increaseInstallment) {
            const key = installment.key;

            if (key <= 1) {
                return `R$${ installment.value } à vista`
            } else {
                const value = (installment.value/key).toFixed(2);

                if (increaseInstallment > 1 && key >= increaseInstallment) {
                    return `${ key } vezes de R$${ value } com juros`;
                    // return `${ key } vezes de R$${ value } com juros - (R$${value.toFixed(2)})`;
                } else {
                    return `${ key } vezes de R$${ value } sem juros`;
                }
            }
        },

        async getAddresses() {
            await window.axios
                .get(
                    `/api/app/addresses/list/${this.user.student.student_id}`
                )
                .then((res) => {
                    this.addresses = res.data.data;
                })
                .catch((err) =>
                    this.$notify({
                        type: 'danger',
                        message: err.response.data.errors,
                    })
                )

            if (this.addresses.length > 0) {
                this.addressId = this.addresses[0].id;
            }
        },

        async saveNewAddress() {
            await this.$store.commit('VALIDATE', true);
            await this.$validator.validate().then(async (valid) => {
                if (valid) {
                    this.$loading.show();
                    await window.axios
                        .post('/api/app/addresses/save', {
                            name: this.address.name,
                            student_id: this.user.student.student_id,
                            location: this.address.location,
                        })
                        .then((res) => {
                            this.$notify({
                                type: 'success',
                                message: res.data.message,
                            });
                            this.getAddresses();
                            this.address.name = '';
                            this.address.location = {};
                            this.newAddress = false;
                        })
                        .catch((err) => {
                            const errors = err.response.data.errors;

                            for (const key in errors) {
                                if (errors.hasOwnProperty(key)) {
                                    const errorMessages = errors[key];

                                    errorMessages.forEach(errorMessage => {
                                        this.$notify({
                                            type: 'danger',
                                            message: errorMessage,
                                        });
                                    });
                                }
                            }
                        })
                        .finally(() => this.$loading.close());
                } else {
                    this.$notify({
                        type: 'danger',
                        message: this.$t('cart.address.invalid'),
                    });
                }
            });
            await this.$store.commit('VALIDATE', false);
        },
        closeAddressModal(address) {
            this.editStates[address.id] = false;
            this.edit = false;
        },
    },

    computed: {
        plans() {
            return this.$store.getters.CART.plans;
        },

        total() {
            if (this.showPagseguroPayment === true) {
                const totalValue = this.$store.getters.CART.total;
                const formattedTotal = totalValue.toFixed(2);
                const numericTotal = formattedTotal;

                return numericTotal;
            } else {
                return this.$store.getters.CART.total;
            }
        },

        message() {
            return this.$store.getters.COUPON_MESSAGE;
        },

        layout() {
            return this.$store.getters.NAVBAR_FIXED;
        },

        isFree() {
            if (this.total === 0) {
                if (!this.gateway) {
                    this.gateway = {"slug": "default-provider"};
                }
                return true;
            }

            if (this.gateway) {
                const isProvider = this.gateway.slug == 'default-provider';
                this.gateway = isProvider ? null : this.gateway;
            }

            return false;
        },

        isValid() {
            return this.$store.getters.FORM_VALID;
        },

        pagseguroCreditCardOption() {
            // Verifica se existe um plano no carrinho, se o plano é recorrente e
            // se está sendo paga uma fatura do aluno, caso esteja sendo paga uma
            // fatura de um plano recorrente, a opção de cartão de crédito do
            // PagSeguro será bloqueada para que o PagSeguro não gere recorrências
            var hasPlan = this.plans && this.plans[0];
            var recurrence = hasPlan && this.plans[0].recurrenceOptions && this.plans[0].recurrenceOptions.length > 0;
            var invoice = this.invoice_id !== null && this.invoice_id !== undefined;
            if (recurrence && invoice) {
                return false;
            }
            return true;
        },
        loadedLocation() {
            return this.$store.getters.LOADED_LOCATION;
        },
        isSinushub() {
            return  window.location.hostname === 'chapolin.nochalks.com'
            || window.location.hostname === 'sinushub3490.nochalks.com'
            || window.location.hostname === 'sinushub.org'
            || window.location.hostname === 'nochalks3php8.io';
        },
    },

    async mounted() {
        this.getPlans();
        this.restoreOptions();
        this.getAddresses();
    },
};
</script>

<style scoped>
@media (min-width: 576px) and (max-width: 990px) {
    .container {
        max-width: 720px !important;
    }
}

.bg-overlay {
    opacity: 0.5;
    pointer-events: none;
}

.cart {
    display: flex;
    flex-wrap: wrap;
}

.cart-title {
    margin-bottom: 1vw;
    font-size: 30px;
}

.payment-type {
    margin-top: 2vw;
    font-size: 25px;
}

.cart-checkout {
    max-width: 100vw;
    display: flex;
    justify-content: center;
}

.cart-checkout button {
    width: 280px;
    margin-top: 1vw;
}

.cart-checkout-paypal {
    max-width: 100vw;
    display: flex;
    justify-content: center;
}

.cart-checkout-paypal button {
    background-color: #2790C3;
    width: 280px;
    margin-top: 1vw;
}

.cart-checkout-pagseguro {
    max-width: 100vw;
    display: flex;
    justify-content: center;
}

.cart-checkout-pagseguro button {
    background-color: #FFC439;
    width: 280px;
    margin-top: 1vw;
}

.cart-card {
    margin-top: 30px;
    border-radius: 1.375rem !important;
    box-shadow: 0 0 1.5rem 0 #5e72e4a3 !important;
}

.payment-method {
    display: flex;
    flex-wrap: wrap;
    margin: 1rem 0 0 0 !important;
    justify-content: center;
}

.group-buttons {
    display: flex;
    font-size: 1.2rem;
    margin-bottom: 3rem !important;
}

.custom-button {
    background-color: white;
    border: 1px solid gray;
    border-radius: 4px;
    color: gray;
    width: 140px;
    /*8vw;*/
    height: 90px;
    /*8vh;*/
    margin-right: 20px;
    /*2vh;*/
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.custom-button span {
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
}

.custom-button svg {
    margin-bottom: 5px;
}

.custom-button.active {
    background-color: #EBF0FF;
    border-color: #355CC2;
    color: #355CC2;
}

.payment-details {
    width: 100vw;
    display: flex;
    flex-direction: column;
}

.payment-details h2 {
    font-size: 25px;
}

.payment-details .details-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media only screen and (max-width: 767px) {
    .custom-button {
        width: 85px;
        height: 60px;
        margin-right: 0.5vw;
    }

    .group-buttons {
        font-size: 0.8rem;
    }

    .custom-button span {
        margin-bottom: 4px;
    }

    .custom-button svg {
        width: 14px;
        height: 14px;
    }

    .cart-checkout-pagseguro button,
    .cart-checkout-paypal button,
    .cart-checkout button {
        font-size: 0.9rem;
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .custom-button {
        width: 115px;
        height: 90px;
        margin-right: 1vw;
    }

    .group-buttons {
        font-size: 1.0rem;
    }
}

.paypal-card {
    margin: 0 0 20px 170px;
    width: 675px;
    border: 1px solid #000000;
    border-radius: 6px;
    padding: 1.5rem;
}

@media (min-width: 994px) and (max-width: 1200px) {
    .paypal-card {
        margin: 0 0 40px 85px;
    }
}

@media (min-width: 100px) and (max-width: 994px) {
    .paypal-card {
        margin: 0 0px 40px 0px;
        width: fit-content;
    }
}


.paypal-card-title {
    display: flex;
    justify-content: center;
    align-items: center;
}

.installments-card {
    display: flex;
    flex-direction: column;
}

.installments-title {
    display: flex;
    justify-content: center;
    align-items: center;
}

.paypal-card p {
    font-size: 1.0rem;
}

@media (min-width: 100px) and (max-width: 994px) {
    .paypal-card h3 {
        font-size: 1rem;
    }

    .paypal-card p {
        font-size: 0.8rem;
    }
}

.billet-card {
    margin: 0 0 20px 170px;
    width: 675px;
    border: 1px solid #000000;
    border-radius: 6px;
    padding: 1.5rem;
}

@media (min-width: 994px) and (max-width: 1200px) {
    .billet-card {
        margin: 0 0 40px 85px;
    }
}

@media (min-width: 100px) and (max-width: 994px) {
    .billet-card {
        margin: 0 0px 40px 0px;
        width: fit-content;
    }
}

.billet-card-title {
    display: flex;
    justify-content: center;
    align-items: center;
}

.billet-card p {
    font-size: 1.2rem;
}

@media (min-width: 100px) and (max-width: 994px) {
    .billet-card h3 {
        font-size: 1rem;
    }

    .billet-card p {
        font-size: 1rem;
    }
}

.spinner-loading {
    position: absolute;
    top: 55%;
    left: 47%;
}

.custom-spacing {
    margin-left: 10px;
}

.thank-you-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: green;
    margin-top: 10%;
    margin-bottom: 10%;
}

.fa-check-circle {
    font-size: 200px;
    margin-bottom: 50px;
}

@media screen and (max-width: 769px) {
    .fa-check-circle {
        font-size: 165px;
    }
}

.thank-you-description {
    font-size: 70px;
}

@media screen and (max-width: 769px) {
    .thank-you-description {
        font-size: 45px;
    }
}

.thank-you-plan-activate {
    font-size: 35px;
}

@media screen and (max-width: 769px) {
    .thank-you-plan-activate {
        font-size: 20px;
    }
}

.plans-btn {
    margin-top: 20px;
    width: 100px;
}

.edit-icon {
    cursor: pointer;
    position: absolute;
    top: 5px;
    right: 10px;
}

.phone-container {
    width: 100%;
}

.phone-title {
    margin-top: 1vw;
    font-size: 25px;
}

.phone-input-container {
    display: flex;
    flex-wrap: wrap;
    margin: 1vw 0vw 0vw 4vw;
}

.invalidField {
    color: red;
    font-size: 0.8rem;
}

.birthdate-input {
    width: 115px;
    margin: 2vw 0vw 0vw 4vw;
}

.birthdate-input-form {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 10px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.birthdate-input-form:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.phone-input-form {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 10px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.phone-input-form:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.phone-input-form-invalid {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 10px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid red;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.phone-input-form-invalid:focus {
    color: #495057;
    background-color: #fff;
    border-color: red;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(231, 9, 9, 0.25);
}

.birthdate-input-form-invalid {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 10px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid red;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.birthdate-input-form-invalid:focus {
    color: #495057;
    background-color: #fff;
    border-color: red;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(231, 9, 9, 0.25);
}

.phone-input-code {
    padding-left: 0px;
    width: 46px;
}

.phone-input-ddd {
    padding-left: 1%;
    width: 65px;
}

.phone-input-number {
    padding-left: 1%;
    width: 130px;
}

.address-container {
    width: 100%;
}

.address-title {
    margin-top: 2vw;
    font-size: 25px;
}

.address-card {
    width: 315px;
    height: 165px;
    margin: 1rem !important;
}

.address-boxes {
    display: flex;
    margin: 1rem 0 1rem 0 !important;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.add-address {
    width: 315px;
    height: 165px;
}

.address-input {
    position: absolute;
    top: 10px;
    left: 10px;
}

.add-address-buttom {
    background-color: white;
    color: black;
    width: 315px;
    height: 165px;
}

.add-address-buttom i {
    font-size: 35px !important;
}

.pix-card-cpf {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.pix-icon-box {
    margin-right: 3vw;
}

.pix-text {
    width: 20vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.pix-card {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 6vw 0 6vw 0;
}

.left-content,
.right-content {
    flex: 1;
    text-align: center;
}

@media screen and (max-width: 500px) {
    .qrcode {
        margin-top: 0 !important;
    }

    .left-content h2 {
        font-size: 1rem;
    }

    .left-content p {
        font-size: 0.8rem;
    }

    .left-content input {
        width: 35vw;
        height: 29px;
    }

    .divider {
        height: 40vw !important;
    }
}

.input-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.copy-icon {
    cursor: pointer;
    display: flex;
    border: 1px solid #767676;
    border-left: none;
    border-radius: 0px 3px 3px 0px;
    height: 30px;
    width: 20px;
    align-items: center;
    justify-content: center;
}

.divider {
    width: 2px;
    height: 20vw;
    background-color: #000;
    margin: 0 20px;
}

.qrcode {
    margin-top: 20px;
    text-align: center;
}

.qrcode img {
    width: 200px;
}

.expiration {
    display: flex;
    justify-content: center;
}

.save-billet {
    display: flex;
    justify-content: flex-end;
}

.save-billet-button {
    width: 225px;
    border-radius: 15px !important;
}

@media screen and (max-width: 500px) {
    .save-billet-button {
        width: 175px;
    }

    .save-billet-text {
        font-size: 10px;
    }

    .save-billet-icon {
        font-size: 10px !important;
    }
}

.cart-checkout-pagseguro button,
.cart-checkout-paypal button,
.cart-checkout button {
    display: flex;
    align-items: center;
    justify-content: center;
}

.cart-checkout-pagseguro button svg,
.cart-checkout-paypal button svg,
.cart-checkout button svg {
    margin-right: 8px;
}
</style>
